var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(this.message),expression:"this.message"}],staticClass:"toast-notification"},[_c('span',{staticClass:"notification-message"},[_vm._v(_vm._s(this.message))]),_c('span',{staticClass:"close",on:{"click":_vm.closeNotification}},[_vm._v("X")])])
}
var staticRenderFns = []

export { render, staticRenderFns }